import React from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { AdminLayout } from '@/components/layout/AdminLayout';

export function AdminDeleteConfirmed() {
  return (
    <AdminLayout>
      <div className="p-8 flex items-center justify-center min-h-[calc(100vh-4rem)]">
        <Card className="bg-card border-border p-8 max-w-md w-full text-center">
          {/* Success Icon */}
          <div className="w-16 h-16 rounded-full bg-green-500/20 flex items-center justify-center mx-auto mb-6">
            <CheckCircle className="w-8 h-8 text-green-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-white mb-2">Event Deleted</h1>
          <p className="text-muted-foreground mb-6">
            The event has been permanently deleted from your account.
          </p>

          <Link to="/admin">
            <Button className="w-full bg-primary text-primary-foreground hover:bg-primary/90">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Button>
          </Link>
        </Card>
      </div>
    </AdminLayout>
  );
}

export default AdminDeleteConfirmed;
